import { type PageObjectUrls } from '../types';

export const convertImageFileToScaledVersions = async (
  imageFile: File,
): Promise<PageObjectUrls> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const sourceUrl = URL.createObjectURL(imageFile);

    img.onload = async () => {
      URL.revokeObjectURL(sourceUrl);
      try {
        const defaultScale = 1; // Original size for default
        const highResScale = 1.4; // 1.4x size for high res

        const defaultResUrl = await scaleImageToBlob(img, defaultScale);
        const highResUrl = await scaleImageToBlob(img, highResScale);

        resolve({
          defaultResObjectUrl: defaultResUrl,
          highResObjectUrl: highResUrl,
        });
      } catch (error) {
        reject(error);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(sourceUrl);
      reject(new Error('Failed to load image'));
    };

    // Load the image
    img.src = sourceUrl;
  });
};

const scaleImageToBlob = async (
  img: HTMLImageElement,
  scale: number,
): Promise<string> => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Failed to get canvas context');
  }

  // Set canvas size based on scale
  canvas.width = img.naturalWidth * scale;
  canvas.height = img.naturalHeight * scale;

  // Draw scaled image
  context.drawImage(img, 0, 0, canvas.width, canvas.height);

  // Convert to blob and return Object URL
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Failed to convert canvas to blob'));
        } else {
          resolve(URL.createObjectURL(blob));
        }
      },
      'image/png',
      1.0,
    );
  });
};
